import React from 'react'
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { DataGrid, TitleLarge } from '../../components';
import { mock_checks } from '../../utils/data';
import { checksConfig } from '../../utils/configs';

const WebChecksPage = () => {
  return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Website-Prüfungen</TitleLarge>
					<DataGrid
						data={mock_checks}
						config={checksConfig}
						keyExtractor={(check) => check.check_id}
					/>
				</PageContent>
			</PageContainer>
		</>
  );
}

export default WebChecksPage